export class ChangesEvent {
    constructor({ event }) {
        this.name = 'changes';
        this.event = event;
    }
    get data() {
        return {
            event: this.event,
        };
    }
}
